/**
 * @zendir/ui — Primitive color palettes (Layer 0)
 *
 * The full color scales endorsed for product design use — Zendir's own
 * system, Astro UXDS status ramps, and Tailwind CSS v4.2. This is the
 * single source of truth that Foundation/Palette in Storybook renders and
 * that themes (src/tokens/themes.ts) and data-viz palettes reference.
 *
 * Layering:
 *   Layer 0 (here)      raw scales — no semantics, never mode-aware
 *   Layer 1 (themes.ts) semantic theme tokens referencing these stops
 *   Layer 2 (apps)      components consume theme tokens / CSS variables
 *
 * Product code should not import these directly for UI surfaces — use the
 * semantic theme tokens. Direct use is appropriate only when defining new
 * palettes (data-viz series, domain color maps).
 */

import { zendirScales } from "./zendir";
import { astroScales } from "./astro";
import { tailwindScales } from "./tailwind";

export * as zendir from "./zendir";
export * as astroUxds from "./astro";
export * as tailwind from "./tailwind";

export {
  base as zendirBase,
  electricBlue,
  prussianBlue,
  ultraviolet,
  neutral as zendirNeutral,
  zendirScales,
} from "./zendir";

export {
  astroStatus,
  astroStatusLightFill,
  astroStatusLightBorder,
  astroScales,
} from "./astro";

export { tailwindScales } from "./tailwind";

/**
 * Everything Foundation/Palette shows, grouped by system. If a scale is
 * here, it's endorsed from a product design POV, whether or not it's
 * already wired into a token in code.
 */
export const allPalettes = {
  zendir: zendirScales,
  astro: astroScales,
  tailwind: tailwindScales,
} as const;
